import api from '@/store/api'

export default {

  loadUser ({ commit }) {
    return api.get('user.json')
      .then(res => res.data.id && commit('SET_USER', res.data))
      .catch(error => console.log(error))
  },

  loadGroups ({ commit }) {
    return api.get('groups.json?isArray=1')
      .then(res => res.data && commit('SET_GROUPS', res.data))
      .catch(error => console.log(error))
  },

  loadEmailAlerts ({ commit }) {
    return api.get('email_alert/email_alerts2.json')
      .then(res => res.data && commit('SET_EMAIL_ALERTS', res.data))
      .catch(error => console.log(error))
  },

  loadTrackedBacktests ({ commit }) {
    return api.get('backtest_tracking.json?isArray=true')
      .then(res => res.data && commit('SET_BACKTESTS', res.data))
      .catch(error => console.log(error))
  },

  loadInsiderAlerts ({ commit }) {
    return api.get('insider_alerts.json')
      .then(res => commit('SET_INSIDER_ALERTS', res.data))
      .catch(error => console.log(error))
  },
  loadTradingModels ({ commit, rootState }) {
    return api.get('trading_models.json')
      .then(res => commit('SET_TRADING_MODELS', {tradingModels:res.data,rootState:rootState}))
      .catch(error => console.log(error))
  }

}
